<template>
  <div class="section landing_dark no-pad-bot" id="index-banner" style="height:80vh">
    <div class="container">
      <br><br>
      <div class="row">
        <div class="col s12">
          <h1 class="header white-text text-darken-3">Thanks for signing up!</h1>
          <p class='white-text'>
            We'll let you know when we're ready to serve you.
          </p>
        </div>
      </div>
      </div>
    </div>
</template>

<script>
export default {}
</script>
